import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import OverflowTip from "components/ui/atoms/OverflowTip";

const CompanyHitShort = ({ onClick, hit, ...props }) => {
  return (
    <ListItemButton onClick={() => onClick && onClick(hit.id, hit)} {...props}>
      <ListItemAvatar variant="small">
        <Avatar src={`http://logo.clearbit.com/${hit.best_domain}`}>
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={<OverflowTip>{hit.best_name}</OverflowTip>}
        secondary={hit.best_domain}
      />
      <ListItemText
        secondary={hit["deal_owner.first_name"]}
        sx={{ maxWidth: "30%", flexGrow: 0, ml: 1 }}
      />
    </ListItemButton>
  );
};

export default CompanyHitShort;
